import { pOturumAc, rKullanici, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IAction, IApiAction, IInputAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import {
  IError,
  IInputDataStateModel,
  DefaultInputDataStateModel,
} from '../../../../models/StateModels';

export const action_api_reset_store = (): IAction<IInputDataStateModel<pOturumAc, rKullanici>> =>
  ActionFunctions.action_api_reset_store(
    ActionSubTypes.API_OTURUMAC,
    DefaultInputDataStateModel<pOturumAc, rKullanici>()
  );

export const action_api_set_input = (body: pOturumAc | null | undefined): IInputAction<pOturumAc> =>
  ActionFunctions.action_api_set_input(ActionSubTypes.API_OTURUMAC, true, body);

export const action_async_start = (body: pOturumAc): IPromiseAction<pOturumAc> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OTURUMAC,
    new Api.User.OturumAc().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rKullanici> | null | undefined,
  error: IError | null | undefined
): IApiAction<rKullanici> =>
  ActionFunctions.action_async_complete_api<rKullanici>(
    ActionSubTypes.API_OTURUMAC,
    data?.Value,
    error
  );
